"use client";

import { useRender } from "@base-ui/react/use-render";
import React from "react";

export { composeRefs } from "shared-web/lib/composeRefs";

export const Slot = ({ children, ...props }: React.HTMLAttributes<HTMLElement>) =>
  useRender({
    defaultTagName: "span",
    render: React.isValidElement(children) ? children : undefined,
    props,
  });

export const Slottable = ({ children }: { children: React.ReactNode }) => <>{children}</>;

export const VisuallyHidden = ({ children }: { children?: React.ReactNode }) => (
  <span className="sr-only">{children}</span>
);
